import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { Input } from "@nextui-org/react";
import { API_URL } from "../../../../api";

export default function WalletCustomerList() {
  const token = localStorage.getItem("token");
  const url = API_URL();

  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [customerLists, setCustomerLists] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const handleWalletToggle = async (patient) => {
    const newWalletStatus = !patient.isWalletUser;
    try {
      await api.patch(`patients-v2/${patient._id}/wallet-status`, {
        isWalletUser: newWalletStatus,
      });
      setCustomerLists((prev) =>
        prev.map((p) =>
          p._id === patient._id ? { ...p, isWalletUser: newWalletStatus } : p,
        ),
      );
      setSearchList((prev) =>
        prev.map((p) =>
          p._id === patient._id ? { ...p, isWalletUser: newWalletStatus } : p,
        ),
      );
    } catch (err) {
      console.error(err);
    }
  };

  const search = (val) => {
    if (val) {
      setSearchList(
        customerLists.filter(
          (el) =>
            el.name?.toLowerCase().includes(val.toLowerCase()) ||
            el.patientID?.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowSearch(true);
    } else {
      setShowSearch(false);
    }
  };

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const res = await api.get("patients-v2/wallet-users");
        setCustomerLists(res.data.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchPatients();
  }, []);

  const displayList = showSearch ? searchList : customerLists;

  return (
    <div className="App">
      <div className="wrapper">
        <div>
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12"></div>
              </div>
            </div>
          </div>

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="row mb-3">
                <div className="col-6 text-start">
                  <h3 className="mb-0">Wallet Customer List</h3>
                </div>
                <div className="col-6 text-end">
                  <Input
                    type="search"
                    className="form-control rounded ml-1"
                    style={{ borderRadius: "12px" }}
                    id="search_code"
                    labelPlaceholder="Search by name or ID"
                    onChange={(e) => search(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead
                                className="sticky-top text-white"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                }}
                              >
                                <tr>
                                  <td>#</td>
                                  <td>CusID</td>
                                  <td>Name</td>
                                  <td>Phone</td>
                                  <td>Branch</td>
                                  <td className="text-center">Action</td>
                                </tr>
                              </thead>

                              <tbody>
                                {displayList.map((sq, i) => (
                                  <tr key={sq._id}>
                                    <td>{++i}</td>
                                    <td>{sq.patientID || "Not Set"}</td>
                                    <td>{sq.name || "Not Set"}</td>
                                    <td>{sq.phone || "Not Set"}</td>
                                    <td>
                                      {sq.relatedBranch
                                        ? sq.relatedBranch.name
                                        : "Not Set"}
                                    </td>
                                    <td className="text-center">
                                      <button
                                        className={`btn btn-sm ${sq.isWalletUser ? "btn-warning" : "btn-success"}`}
                                        onClick={() => handleWalletToggle(sq)}
                                      >
                                        {sq.isWalletUser
                                          ? "Disable User"
                                          : "Enable User"}
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                                {displayList.length === 0 && (
                                  <tr>
                                    <td
                                      colSpan={6}
                                      className="text-center py-4"
                                    >
                                      No wallet customers found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
